import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router-dom'

import './logo.scss'

const Logo = props => {

    const className = cx(
        'logo',
        { 'black-theme': props.isFooter }
    )

    return (
        <a href="https://delight-xr.com/" target="_blank" className={className}>
            <img src="/Delight-VR-Logo-Green.svg" alt="DelightVR Logo" />
            <div>
                powered by
                <span>Delight XR</span>
            </div>
        </a>
    )
}

export default Logo


// WEBPACK FOOTER //
// ./src/components/shared/logo/index.jsx